'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _updateChildKeys = require('./updateChildKeys');

var _updateChildKeys2 = _interopRequireDefault(_updateChildKeys);

var _unshift = require('unmutable/lib/unshift');

var _unshift2 = _interopRequireDefault(_unshift);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipe = require('unmutable/lib/util/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var value = _ref.value;

    return (0, _pipe2.default)((0, _update2.default)('value', (0, _unshift2.default)(value)), (0, _update2.default)('child', (0, _unshift2.default)({})), (0, _updateChildKeys2.default)());
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/unshift.js
// module id = 758
// module chunks = 35783957827783